import ownerDocument from './owner-document';

var getDocument = function getDocument(element) {
  return ownerDocument(element).documentElement;
};

export default getDocument;